export default [
  {
    title: "Dashboard",
    customIcon: "CustomSVG",
    children: [
      {
        title: "Dashboard",
        route: "custom-module",
        path: "/custom-module/dashboard",
      },
    ],
  },
];
